import * as LayoutPropsActions from './layout-props';
import * as UserActions from './user';

export default function (dispatch) {
  return { actions: {
    setLayoutProps: (props) => dispatch(LayoutPropsActions.setLayoutProps(props)),
    setUser: (user) => dispatch(UserActions.setUser(user)),
  } };
}
